<template>
    <div>
        <div class="flex items-center">
            <div class="h-4 w-4 rounded-full" :class="colorState"></div>
            <div class="ml-4">
                <div v-if="labelMessage" class="font-bold">{{$tt(labelMessage)}}</div>
                <div v-if="labelState || labelDate" class="-mt-1 font-light text-sm">
                    {{$tt(labelState)}}
                    <span v-if="labelState && labelDate">, </span>
                    <span v-if="labelDate">{{labelDate}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    props: {
        state: { 
            required: true
        },

        label: {},

        date: {}
    },

    computed: {
        colorState() {
            if (this.state == 0) {
                return 'bg-gray-600'
            }
            if (this.state == 1) {
                return 'bg-orange-600'
            }
            if (this.state == 2) {
                return 'bg-green-600'
            }
            return 'bg-gray-600'
        },

        labelState() {
            if (this.state == 0) {
                return this.$t('mes_produits.badge-etat.en_cours')
            }
            if (this.state == 1) {
                return this.$t('mes_produits.badge-etat.en_attente')
            }
            if (this.state == 2) {
                return this.$t('mes_produits.badge-etat.termine')
            }
        },

        labelMessage() {
            return this.label
        },

        labelDate() {
            if (this.date) {
                let parsedDate = moment(this.date).lang("fr").fromNow()
                parsedDate = parsedDate[0].toUpperCase() + parsedDate.slice(1)
                return parsedDate
            }
        }
    },

    methods: {
        folderStateBadge() {
            let badge = null
            if (this.state != null) {
                if (this.state == 0) {
                    badge = '<div class="flex items-center"><div class="h-4 w-4 bg-gray-600 rounded-full"></div><div class="text-sm ml-2">' + this.$t('mes_produits.badge-etat.en_cours')
                }
                if (this.state == 1) {
                    badge = '<div class="flex items-center"><div class="h-4 w-4 bg-orange-600 rounded-full"></div><div class="text-sm ml-2">' + this.$t('mes_produits.badge-etat.en_attente')
                }
                if (this.state == 2) {
                    badge = '<div class="flex items-center"><div class="h-4 w-4 bg-green-600 rounded-full"></div><div class="text-sm ml-2">' + this.$t('mes_produits.badge-etat.termine')
                }
            } else {
                badge = '<div class="flex items-center"><div class="h-4 w-4 bg-gray-600 rounded-full"></div><div class="text-sm ml-2">'
            }


            if (this.label) {
                if (this.state) {
                    badge += ' <div class="mx-2">|</div> ' + this.label
                    badge += '</div></div>'
                // } else {
                //     badge += this.label
                //     badge += '</div></div>'
                }
            }

            return badge
        },
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/BadgeState.vue